"use strict";

exports.__esModule = true;
exports.default = exports.AnalyticsContext = void 0;

var _react = _interopRequireWildcard(require("react"));

var _loadGa = _interopRequireDefault(require("./load-ga"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var AnalyticsContext = /*#__PURE__*/_react.default.createContext({
  gtag: function gtag() {}
});

exports.AnalyticsContext = AnalyticsContext;

function gtag() {
  window.dataLayer.push(arguments);
}

var Analytics = function Analytics(_ref) {
  var userManager = _ref.userManager,
      debugMode = _ref.debugMode,
      appName = _ref.appName,
      children = _ref.children;
  (0, _react.useEffect)(function () {
    (0, _loadGa.default)();
    window.dataLayer = window.dataLayer || [];
    userManager.getUser().then(function (user) {
      var debugProps = debugMode ? {
        debug_mode: debugMode
      } : {};
      var userProps = {};

      if (user && user.expired === false) {
        userProps.user_id = user.profile.sub;

        if (user.profile.colleague) {
          userProps.user_properties = {
            store: user.profile.colleague.assignments[0].locationCode,
            grade: user.profile.colleague.assignments[0].jobGrade,
            role: user.profile.colleague.assignments[0].jobName
          };
        }
      }

      gtag('js', new Date());
      gtag('config', 'G-WR4J0KE1LK', Object.assign({
        app_name: appName
      }, debugProps, userProps));
    });
  }, []);
  return /*#__PURE__*/_react.default.createElement(AnalyticsContext.Provider, {
    value: {
      gtag: gtag
    }
  }, children);
};

Analytics.propTypes = {
  userManager: _propTypes.default.object.isRequired,
  debugMode: _propTypes.default.bool,
  appName: _propTypes.default.string.isRequired
};
Analytics.defaultProps = {
  debugMode: false
};
var _default = Analytics;
exports.default = _default;